/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react';
import {
  Card,
  Alert,
  Typography,
  Link
} from '@one-thd/sui-atomic-components';
import PropTypes from 'prop-types';
import ProjectsHeader from './ProjectsHeader/ProjectsHeader';
import { recordRetryAttempt } from '../utils/retryTracker';

const ProjectsError = ({ refresh, componentId }) => {
  return (
    <div
      data-component="ProjectsError"
      data-testid="projects-container-error"
      className="sui-h-full"
    >
      <div className="sui-mb-4">
        <ProjectsHeader hideActions componentId={componentId} />
      </div>

      <div className="sui-h-full [&>*]:sui-h-[calc(100%-64px)] [&>*>*]:sui-h-full">
        <Alert status="error" size="large">
          <div>
            <Typography variant="body-base" weight="bold">Something went wrong during loading</Typography>
            <Typography variant="body-base">
              <Link onClick={async (event) => {
                event.preventDefault();
                try {
                  // Record retry attempt before refreshing
                  recordRetryAttempt();
                  await refresh();
                } catch (err) {
                  // eslint-disable-next-line no-console
                  console.error('Error refreshing projects:', err);
                }
              }}
              >
                Refresh Projects
              </Link> to try again.
            </Typography>
          </div>
        </Alert>
      </div>
    </div>
  );
};

export default ProjectsError;

ProjectsError.propTypes = {
  refresh: PropTypes.func.isRequired,
  componentId: PropTypes.string,
};

ProjectsError.defaultProps = {
  componentId: '',
};